var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 15" }, props),
    React.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "8.4", cy: "5.9", r: "2.8" }),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M10.5 11.2c-.4-.4-.6-.9-.7-1.4-.4.2-.9.3-1.4.3-2.6 0-5-2.8-5.9-4 1.1-1.5 3.5-4 5.9-4 2.6 0 5 2.8 5.9 4-.2.3-.5.7-.9 1.1.2.1.5.3.6.5l.9.9c.6-.6 1.1-1.3 1.6-1.9.2-.3.2-.8 0-1.1-.2-.2-3.6-5.5-8-5.5S.7 5.3.5 5.5c-.2.3-.2.8 0 1.1.2.3 3.6 5.5 8 5.5.8 0 1.7-.2 2.4-.5l-.4-.4z" }),
    React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M16.2 14.9c-.4 0-.8-.2-1.1-.4l-3.8-3.8c-.6-.6-.5-1.6.1-2.1s1.5-.5 2 0l2.7 2.7 5-5c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2l-6.1 6.1c-.2.2-.5.4-.9.4z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/InspectedAndApproved.svg